import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { previewInvitation } from '@/api/invitations/invitationsApi';
import type { InvitationPreview } from '@/api/invitations/invitationsApi.types';
import { buildInvitationPreviewQueryKey } from '@/constants/queryKeys';

export function useInvitationPreviewQuery(
  token: string
): UseQueryResult<InvitationPreview, Error> {
  return useQuery({
    queryKey: buildInvitationPreviewQueryKey(token),
    queryFn: function loadInvitationPreview() {
      return previewInvitation(token);
    },
    enabled: token.length > 0,
    retry: false,
  });
}
